var borders_default = {
  "borderT": "J1h5D",
  "borderB": "uDyyt",
  "borderL": "Fi1GW",
  "borderR": "jmP-O",
  "borderColorOverride": "_4wlm9"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
